export const QUERY_KEY_DATASET_VERSION_LIST = 'dataset-version-list'

export const DATASET_VERSION_LIST_QUERY_KEY = (params: (string | number)[]) =>
  [QUERY_KEY_DATASET_VERSION_LIST, ...(params ? [params] : [])] as const
